module.exports = __webpack_public_path__ + "237187285e91604a53dcc2253bea4e68.png";